module.exports = __webpack_public_path__ + "img/car_damage.b14ab6cd.svg";